import { Country } from '../../../models/country.model';

export const COUNTRIES: readonly Country[] = [
  { key: 'en-us', label: 'United States', icon: 'us.svg' },
  { key: 'en-gb', label: 'UK', icon: 'uk.svg' },
  { key: 'en-ie', label: 'Ireland', icon: 'ie.svg' },
  { key: 'en-ca', label: 'Canada', icon: 'ca.svg' },
  { key: 'en-au', label: 'Australia', icon: 'au.svg' },
  { key: 'en-nz', label: 'New Zealand', icon: 'nz.svg' },
  { key: 'es-es', label: 'España', icon: 'es.svg' },
  { key: 'it-it', label: 'Italia', icon: 'it.svg' },
  { key: 'pl-pl', label: 'Polska', icon: 'pl.svg' },
  { key: 'zh-tw', label: '台灣', icon: 'tw.svg' },
  { key: 'ja-jp', label: '日本', icon: 'jp.svg' },
] as const;
